import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";

// styles and images
import togglePwOn from "../../assets/pw_vis_on.svg";
import togglePwOff from "../../assets/pw_vis_off.svg";
import "./Login.css";
import { awsDataStore, userStore } from "../../store/Store";
import PasswordReset from "./PasswordReset";

export default function Login() {
  // global state
  const setCurrentUser = userStore(
    (userDataStore) => userDataStore.setCurrentUser
  );
  const setJwtToken = userStore((userDataStore) => userDataStore.setJwtToken);
  const setCurrentCompany = userStore(
    (userDataStore) => userDataStore.setCurrentCompany
  );
  const currentCompany = userStore(
    (userDataStore) => userDataStore.currentCompany
  );
  const currentUser = userStore((userDataStore) => userDataStore.currentUser);
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);
  const setProfilePic = awsDataStore((data) => data.setProfilePic);
  const setAuthStatus = userStore((data) => data.setAuthStatus);

  // state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pwIcon, setPwIcon] = useState(togglePwOn);
  const [showPassword, setShowPassword] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [formError, setFormError] = useState(null);
  const [resetPasswordTrigger, setResetPasswordTrigger] = useState(false);

  // context
  const { setShowSettings } = useOutletContext();
  const { toggleRefresh } = useOutletContext();
  // other
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsPending(true);
    // build request payload
    let payload = {
      email: email,
      user_password: password,
    };
    const controller = new AbortController();
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(payload),
      signal: controller.signal,
    };

    fetch(`${process.env.REACT_APP_BACKEND}/authenticate`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          setFormError("Invalid Credentials");
          setIsPending(false);
        } else {
          setShowSettings(false);
          setJwtToken(data.tokens.access_token);
          setIsPending(false);
          toggleRefresh(true);
          setCurrentUser({
            id: data.current_user.id,
            display_name: data.current_user.display_name,
            role_name: data.current_user.role_name,
            is_approved: data.current_user.is_approved,
            company_id: data.current_user.company_id,
            first_name: data.current_user.first_name,
            last_name: data.current_user.last_name,
          });
          setCurrentCompany(data.company);
          setAuthStatus(true);
          navigate("/");
        }
      })
      .catch((error) => {
        setFormError(error);
      })
      .finally(() => setIsPending(false));
    return () => controller.abort();
  };

  useEffect(() => {
    if (currentUser && JwtToken && currentCompany) {
      const headers = new Headers();
      const controller = new AbortController();
      headers.append("Authorization", `Bearer ${JwtToken}`);
      const requestOptions = {
        method: "GET",
        headers: headers,
        signal: controller.signal,
      };
      fetch(
        `${process.env.REACT_APP_BACKEND}/lc/get-file/${
          currentUser.id
        }/${"profile-pics"}/{jpeg}?user_id=${currentUser.id}`,
        requestOptions
      )
        .then((res) => res.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          setProfilePic(url);
        })
        .catch((err) => {
          console.log(err);
          return;
        });
      return () => controller.abort();
    }
  }, [currentUser, JwtToken, setProfilePic, currentCompany]);

  const togglePassword = () => {
    if (!showPassword) {
      setShowPassword(true);
      setPwIcon(togglePwOff);
    } else {
      setShowPassword(false);
      setPwIcon(togglePwOn);
    }
  };

  return (
    <div className="container">
      <div className="row d-flex justify-content-center align-items-center h-100">
        <div className="col-12 col-md-8 col-lg-6 col-xl-5">
          <div
            className="card shadow-2-strong"
            style={{ borderRadius: "1rem" }}
          >
            <div className="card-body p-5 text-center">
              <h2>Log In</h2>
              <form onSubmit={handleSubmit}>
                <div className="form-outline mb-4">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control form-control-lg"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    name="Email"
                  />
                </div>
                <div className="form-outline mb-4">
                  <label className="form-label">Password</label>
                  <div className="pw-container">
                    <input
                      type={!showPassword ? "password" : "text"}
                      className="form-control form-control-lg"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                    />
                    <img src={pwIcon} className="password-toggle" onClick={togglePassword} alt="toggle" />
                  </div>
                </div>
                {!isPending && <button className="propx-btn">Login</button>}
                {isPending && (
                  <button className="propx-btn" disabled>
                    Loading
                  </button>
                )}
                {formError && <div className="error">{formError}</div>}
              </form>
              <div className="row">
                <span
                  className="reset-password"
                  onClick={() => setResetPasswordTrigger(true)}
                >
                  reset password
                </span>
              </div>
              {resetPasswordTrigger && (
                <PasswordReset setTrigger={setResetPasswordTrigger} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
